import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { tradingTimeInterval } from '../../../../helpers/Common';
import RowClick from '../../../../common/RowClick';
import Const from './Const';
import {
  REDUCER_NAME,
  intervalFetchAllValue,
  loadMoreAllValue,
  changeIndustryTableDropDown,
  fetchValueInvestment,
} from './reducer';
import { compose } from 'redux';
import STTable from '../../../../common/mixTable/STTable';
import ConstCommon from '../../common/Const';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../../app/commonReducer';
import { I18n } from 'react-redux-i18n';

class LeadersTableRanking extends React.Component {
  constructor(props) {
    super(props);
    this.initialState = {
      page: 1,
      pageSize: Const.maxRowData,
      rankingId: 1,
      isHover: false,
      lstDataIndustry: [],
    };
    this.state = this.initialState;
  }

  componentDidMount() {
    const {
      intervalFetchAllValue,
      listIndustryByIcbLevel,
      fetchValueInvestment,
    } = this.props;
    intervalFetchAllValue(true);
    fetchValueInvestment();
    this.setStateListDropdown(listIndustryByIcbLevel);
  }

  setStateListDropdown = listIndustryByIcbLevel => {
    let lstData = !_.isEmpty(listIndustryByIcbLevel)
      ? _.orderBy(listIndustryByIcbLevel[3], ['icbName'], ['asc'])
      : [];
    const itemAllIndustries = {
      ...Const.itemAllIndustries,
      icbName: I18n.t('strategy.AllIndustries'),
    };
    lstData = _.concat(itemAllIndustries, lstData);
    this.setState({
      lstDataIndustry: lstData,
    });
  };

  componentDidUpdate(prevProps, prevState) {
    const { intervalFetchAllValue, listIndustryByIcbLevel } = this.props;
    if (prevProps.i18n.locale !== this.props.i18n.locale) {
      intervalFetchAllValue(true);
    }
    const lstPrevListIndustry = prevProps
      ? prevProps.listIndustryByIcbLevel
      : [];
    if (!_.isEqual(listIndustryByIcbLevel, lstPrevListIndustry)) {
      this.setStateListDropdown(listIndustryByIcbLevel);
    }
  }
  getDataFromRedux = state => {
    return state[REDUCER_NAME].listAllValueByTicker;
  };

  handleScroll = e => {
    const { page } = this.state;
    const { totalPage, ids } = this.props;
    if (page === totalPage) return;
    if (ids.length < Const.maxRowData) return;
    const bottom =
      e.target.scrollTop !== 0 &&
      e.target.scrollHeight - Math.round(e.target.scrollTop) ===
        e.target.clientHeight;
    if (bottom) {
      this.loadMoreActive();
    }
  };

  loadMoreActive = () => {
    const {
      loadMoreAllValue,
      listAllValueLoadMore,
      listAllValueByTicker,
      totalPage,
      industryId,
      isLoading,
      scoreId,
      page,
    } = this.props;
    if (page === totalPage || isLoading) return;
    let pageCurrent = parseInt(page);
    this.setState(() => {
      loadMoreAllValue({
        Page:
          _.isEmpty(listAllValueLoadMore) &&
          !_.isEmpty(listAllValueByTicker) &&
          pageCurrent > 1
            ? pageCurrent
            : pageCurrent + 1,
        Code: industryId,
        scoreId,
      });
    });
  };

  renderTable() {
    const {
      isLoading,
      ids,
      changeIndustryTableDropDown,
      currentSelectedIndustryTable,
    } = this.props;
    const { lstDataIndustry } = this.state;

    return (
      <RowClick>
        {onRowClick => (
          <STTable
            onRowClick={onRowClick}
            ids={ids}
            isLoading={isLoading}
            getDataFromRedux={this.getDataFromRedux}
            schemaKey="stRanking.fiinTradeRankingsHeader"
            listColumn={ConstCommon.listColumn}
            handleScroll={this.handleScroll}
            listIndustry={lstDataIndustry}
            changeIndustryTableDropDown={changeIndustryTableDropDown}
            currentSelectedIndustryTable={currentSelectedIndustryTable}
          />
        )}
      </RowClick>
    );
  }

  render() {
    return this.renderTable();
  }
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    ids: state[REDUCER_NAME].listTickerAllValue,
    currentSelectedIndustryTable:
      state[REDUCER_NAME].currentSelectedIndustryTable,
    listAllValueByTicker: state[REDUCER_NAME].listAllValueByTicker,
    listAllValueLoadMore: state[REDUCER_NAME].listAllValueLoadMore,
    listIndustryByIcbLevel: state[COMMON_REDUCER_NAME].listIndustryByIcbLevel,
    organCode: state[REDUCER_NAME].organCode,
    isLoading: state[REDUCER_NAME].isLoading,
    totalPage: state[REDUCER_NAME].totalPage,
    firstPage: state[REDUCER_NAME].firstPage,
    page: state[REDUCER_NAME].page,
  };
};

const mapDispatchToProps = {
  loadMoreAllValue,
  fetchValueInvestment,
  changeIndustryTableDropDown,
  intervalFetchAllValue,
};

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);

export default enhance(LeadersTableRanking);
